import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import FeatureMediaSection from './components/FeatureMediaSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CarouselSection />
        <CardsSection />
        <RankingSection />
        <FeatureMediaSection />
        <CommentsSection />
        <ContactSection />
        <TopicsSection />
        <AboutSection />
        <IndexSection />
        <UpdatesSection />
        <AppSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}